{
  "settings": "Postavke",
  "yourDigitalAssistant": "Vaš digitalni asistent",
  "getStarted": "Počni",
  "login": "Prijaviti se",
  "loggingIn": "Prijavljivanjem ...",
  "darkMode": "Tamni mod",
  "clearHistory": "Obriši istoriju",
  "historyCleared": "Istorija izbrisana",
  "changeLanguage": "Jezik",
  "termsAndConditions": "Pravila korištenja",
  "messagePlaceholder": "Unesite svoju poruku ovdje ...",
  "messagePlaceholderDisabled": "Kucanje onemogućeno ...",
  "feedbackTitle": "Procijenite svoje iskustvo",
  "feedbackPlaceholder": "Recite nam o tome (neobavezno)",
  "feedbackSend": "Pošaljite",
  "feedbackClose": "blizu",
  "sessionExpired": "Vaša sesija je istekla zbog neaktivnosti.",
  "startNewSession": "Зzapočnite novu sesiju",
  "apiError": "Ups! Nešto nije u redu. Radimo na tome da to popravimo što prije možemo.",
  "apiErrorOffline": "Niste povezani na Internet.",
  "tryAgain": "pokušaj ponovo",
  "startOver": "Početi ponovo",
  "chatEnded": "Razgovor je završen.",
  "chatEndedThankYou": "Hvala vam što ste razgovarali s nama!",
  "closeChat": "blizu",
  "startNewChat": "Ponovo razgovarajte",
  "humanTakeoverStarted": "Sada ste prebačeni u korisničku službu ...",
  "humanTakeoverQueued": "Čeka da se povežem s agentom",
  "humanTakeoverAnAgent": "Agente",
  "humanTakeoverAgentEntered": "ušao u razgovor",
  "humanTakeoverAgentLogout": "napustio razgovor",
  "humanTakeoverTransfer": "Prelazite kod novog agenta",
  "humanTakeoverEnded": "Sada razgovarate s digitalnim asistentom",
  "version": "Verzija",
  "formIntroText": "Ispunite sljedeći obrazac da biste započeli razgovor s nama.",
  "formFirstName": "Ime",
  "formLastName": "Prezime",
  "formName": "Ime",
  "formEmail": "E-mail",
  "formWrongEmail": "Molimo Vas da unesete validnu email adresu.",
  "formPhone": "Telefon",
  "formShipmentId": "ID pošiljke",
  "formQuestion": "Tvoje pitanje",
  "formAccountNumber": "Broj računa (za poslovne kupce)",
  "formAddress": "Adresa",
  "formPostcode": "poštanski broj",
  "formCity": "Grad",
  "formCountry": "Zemlja",
  "formSubmitButton": "Počnite čavrljati",
  "formEmptyFieldError": "Nije dozvoljeno da bude prazno.",
  "formPhoneNumberValidationError": "Nevažeći telefonski broj.",
  "formInputIsBiggerThan50": "Mora sadržavati najviše 50 znakova.",
  "formInputIsBiggerThan100": "Mora sadržavati najviše 100 znakova",
  "formInputIsBiggerThan2000": "Mora sadržavati najviše 2000 znakova",
  "widgetEventOnline": "DA poruka: Korisnik je ponovo na mreži.",
  "widgetEventHidden": "DA poruka: Widget je skriven.",
  "widgetEventVisible": "DA poruka: Vidžet je vidljiv.",
  "widgetEventVisibleMinimized": "DA poruka: Dodatak je vidljiv, ali smanjen.",
  "widgetEventMinimized": "DA poruka: Widget je minimiziran.",
  "widgetEventMaximized": "DA poruka: Widget je maksimiziran.",
  "widgetEventSessionExpired": "DA poruka: Sesija vidžeta je istekla.",
  "widgetEventHangupHuman": "ДА порука: Корисник завршава сесију преузимања човека.",
  "widgetEventUserTyping": "DA poruka: Korisnik kuca.",
  "fileTooLarge": "Pokušavate priložiti prevelike datoteke.",
  "tooManyDiles": "Pokušavate priložiti previše datoteka.",
  "fileInvalidType": "Pokušavate priložiti nevažeće vrste datoteka.",
  "attachmentsDropHere": "Spustite ovdje za upload ili",
  "attachmentsBrowse": "Pregledajte datoteke",
  "attachmentsExtenstionQuantity": "pdf ili slike (do 10 datoteka)",
  "attachmentsSize": "do 30 MB",
  "attachmentsFailedUploading": "Otpremanje nije uspjelo",
  "attachmentsUploading": "Otpremanje ...",
  "minimizeExpandText": "Razgovarajte uživo s nama sada!",
  "popupWidgetNotificationMessage": "Dobili ste novu poruku!",
  "tabWidgetNotificationMessage": "Nova poruka!",
  "datepickerSendButton": "Poslati"
}
